import { IconLiquidity, theme } from '@capitalise/ui-design-system';
import { formatCurrency } from 'utils/NumberHelper';
import ProductInfo from './ProductInfo';
import PropTypes from 'prop-types';

const ProductMerchantDescription = ({ fundingAmount, totalRepayment, sweep, ratio }) => {
  return (
    <>
      <ProductInfo
        value={formatCurrency(fundingAmount)}
        label="Founding Amount"
        icon={<IconLiquidity color="grey-500" width={theme.sizes['tiny']} />}
      />
      <ProductInfo value={`${sweep} %`} label="Sweep" icon={'%'} />
      <ProductInfo
        value={formatCurrency(totalRepayment)}
        label="Total repayment"
        icon={<IconLiquidity color="grey-500" width={theme.sizes['tiny']} />}
      />
      <ProductInfo value={ratio} label="Ratio" icon={'%'} />
    </>
  );
};

ProductMerchantDescription.propTypes = {
  fundingAmount: PropTypes.number,
  totalRepayment: PropTypes.number,
  sweep: PropTypes.number,
  ratio: PropTypes.number,
};

export default ProductMerchantDescription;
